export default "__VITE_ASSET__CfKEM0DM__"